import { useState } from "react"
import { Play, X } from "react-feather"
import CryptoJS from "crypto-js"
import { VideoPlayerPopup } from "../../../CommonPopup/VideoPlayerPopup/VideoPlayerPopup"

export const WebinarVideoViewPopup = ({ WebinarVideoData, cancelbtn }) => {
  const [activeVideoUrl, setActiveVideoUrl] = useState("")
  const data = WebinarVideoData?.data || {}

  let videos = []

  if (data?.videosdetails) {
    try {
      const key = CryptoJS.enc.Utf8.parse("b14ca5898a4e4133bbce2ea2315a1916")
      const iv = CryptoJS.enc.Utf8.parse("fedcba9876543210")
      const decoded = decodeURIComponent(data.videosdetails).replace(/ /g, "+")
      const bytes = CryptoJS.AES.decrypt(decoded, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      })
      const decryptedText = bytes.toString(CryptoJS.enc.Utf8)
      const decryptedData = JSON.parse(decryptedText)
      console.log("decryptedData", decryptedData)
      videos = Array.isArray(decryptedData) ? decryptedData : [decryptedData]
    } catch (error) {
      try {
        const decoded = decodeURIComponent(data.videosdetails).replace(/ /g, "+")
        const bytes = CryptoJS.AES.decrypt(decoded, "b14ca5898a4e4133bbce2ea2315a1916")
        const decryptedText = bytes.toString(CryptoJS.enc.Utf8)
        const decryptedData = JSON.parse(decryptedText)
        console.log("decryptedData", decryptedData)
        videos = Array.isArray(decryptedData) ? decryptedData : [decryptedData]
      } catch (err) {
        console.log("Invalid Data", err)
      }
    }
  } else if (Array.isArray(data?.video)) {
    videos = data.video
  }

  const getVideoUrl = (video) => video?.videoUrl || video?.videoPath || video?.VideoURL || video?.VideoUrl || video?.VideoPath || ""
  const getThumbnailUrl = (video) => video?.thumbnailUrl || video?.thumbnailPath || video?.ThumbnailURL || video?.ThumbnailUrl || video?.ThumbnailPath || ""
  const getVideoName = (url) => {
    return url ? url.split("/").pop().split("?")[0] : ""
  }

  return (
    <div className="seminar-backdrop custom">
      <div className="modal-dialog modal-dialog-centered seminar-dialog seminar-video-dialog">
        <div className="modal-content seminar-content">

          {/* Header */}
          <div className="d-flex align-items-center justify-content-between seminar-header">
            <h6 className="m-0 fw-bold">View Webinar Video</h6>
            <button
              type="button"
              className="btn-close btn-close-white seminar-close"
              onClick={cancelbtn}
            />
          </div>

          {/* Body */}
          <div className="seminar-body">
            <div className="row g-3">

              <div className="col-12">
                <div className="seminar-label">Title Name</div>
                <div className="form-control seminar-control bg-light">{data.titleName || "-"}</div>
              </div>

              <div className="col-12">
                <div className="seminar-label">Sub Title Name</div>
                <div className="form-control seminar-control bg-light">{data.subTitleName || "-"}</div>
              </div>

              <div className="col-12">
                <div className="seminar-label">Description</div>
                <div className="form-control seminar-control bg-light text-break">{data.description || "-"}</div>
              </div>

              <div className="col-12">
                <div className="seminar-label">Videos</div>

                {videos.length === 0 && (
                  <div className="form-control seminar-control bg-light">No videos available</div>
                )}

                {videos.map((video, index) => (
                  <div className="seminar-video-upload-section" key={index}>
                    <strong className="d-block mb-2">Video {index + 1}</strong>

                    <div className="seminar-video-upload-grid">

                      {/* Video */}
                      <div>
                        <div className="seminar-video-field-label">Video Upload</div>
                        <div className="seminar-video-dropzone">
                          {getVideoUrl(video) ? (
                            <button
                              type="button"
                              onClick={() => setActiveVideoUrl(getVideoUrl(video))}
                              className="seminar-video-file-link"
                            >
                              <Play size={12} fill="currentColor" /> {getVideoName(getVideoUrl(video))}
                            </button>
                          ) : (
                            <div className="form-control seminar-control bg-light">No video available</div>
                          )}
                        </div>
                      </div>

                      {/* Thumbnail */}
                      {/* <div>
                        <div className="seminar-video-field-label">Thumbnail Image</div>
                        <div className="seminar-video-dropzone seminar-thumbnail-dropzone d-flex justify-content-center align-items-center">
                          {getThumbnailUrl(video) ? (
                            <a
                              href={getThumbnailUrl(video)}
                              target="_blank"
                              rel="noreferrer"
                              className="seminar-view-image-link"
                            >
                              <img
                                src={getThumbnailUrl(video)}
                                alt={"Video " + (index + 1) + " thumbnail"}
                                className="seminar-video-thumbnail"
                              />
                            </a>
                          ) : (
                            <div className="form-control seminar-control bg-light">No thumbnail</div>
                          )}
                        </div>
                      </div> */}

                    </div>
                  </div>
                ))}
              </div>

            </div>
          </div>

          {/* Footer */}
          <div className="d-flex justify-content-end seminar-footer">
            <button type="button" className="btn btn-danger seminar-btn-cancel" onClick={cancelbtn}>
              <X size={15} className="me-1" />
              Close
            </button>
          </div>

        </div>
      </div>
      {activeVideoUrl && (
        <VideoPlayerPopup
          videoUrl={activeVideoUrl}
          onClose={() => setActiveVideoUrl("")}
        />
      )}
    </div>
  )
}